import { render, staticRenderFns } from "./file.vue?vue&type=template&id=7c89e78a&scoped=true&lang=pug"
import script from "./file.vue?vue&type=script&lang=js"
export * from "./file.vue?vue&type=script&lang=js"
import style0 from "./file.vue?vue&type=style&index=0&id=7c89e78a&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c89e78a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\G\\YT\\mes-project-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c89e78a')) {
      api.createRecord('7c89e78a', component.options)
    } else {
      api.reload('7c89e78a', component.options)
    }
    module.hot.accept("./file.vue?vue&type=template&id=7c89e78a&scoped=true&lang=pug", function () {
      api.rerender('7c89e78a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wl-component-gallery/wl-upload/components/file.vue"
export default component.exports